import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { withRouter, useLocation } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";

import { makeStyles } from "@material-ui/core/styles";
import Hidden from "@material-ui/core/Hidden";
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";

import Button from "components/CustomButtons/Button.js";
import AlertMinTotal from "componentsCustom/AddItem/AlertMinTotal.js";
import AddItemCustom from "componentsCustom/AddItem/AddItemCustom.js";
import PromotionalCode from "container/componentsCustom/PromotionalCodeContainer.js";

import cartStyle from "assets/jss/material-dashboard-pro-react/views/cartStyle.js";
import {
  warningColor,
  hexToRgb,
} from "assets/jss/material-dashboard-pro-react.js";

import { priceTotal, calculateValueCurrency } from "util/calculation";
import pathSplit from "util/pathSplit";
import moment from "moment";
import { IconButton } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import EventInfoAlert from "../componentsCustom/Sidebar/EventInfoAlert";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";

const useStyles = makeStyles(cartStyle);

function SidebarCart(props) {
  const { t } = useTranslation();
  let location = useLocation();

  const {
    cart,
    updateCart,
    language,
    currency,
    museum,
    history,
    customStyle,
    // shippingInfo,
    cartParams,
    // articles,
    // eslint-disable-next-line
    closeCartSideBar,
    // eslint-disable-next-line
    showGoToCheckout = true,
    events,
  } = props;

  const classes = useStyles();

  const [showAlert, setShowAlert] = useState(false);
  const [showModalEventInfo, setShowModalEventInfo] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 960);
  const [showMoreActive, setShowMoreActive] = useState(false);
  const [showPlacesWarning, setShowPlacesWarning] = useState(false);
  const [showEntrancesWarning, setShowEntrancesWarning] = useState(false);
  const [showCartFullWarning, setShowCartFullWarning] = useState(false);

  const [capacity, setCapacity] = useState(0);
  const [problematicDateTime, setProblematicDateTime] = useState("");

  useEffect(() => {
    setCapacity(museum.capienza_massima);
  }, [museum]);

  useEffect(() => {
    window.addEventListener("resize", resizeFunction);

    // Specify how to clean up after this effect:
    return function cleanup() {
      window.removeEventListener("resize", resizeFunction);
    };
  }, []);

  const resizeFunction = () => {
    if (window.innerWidth < 960) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  const remainingPlaces = (evento_child) => {
    const avPlaces = evento_child.posti_disponibili;
    const eventPlacesInCart = cart.filter(
      (obj) =>
        obj.item.schema_eventi.id === evento_child.main_event &&
        moment(obj.dateTimeSelected).isSame(evento_child.ora_inizio)
    );
    if (eventPlacesInCart.length > 0) {
      return (
        avPlaces - eventPlacesInCart.reduce((t, obj) => t + obj.quantity, 0)
      );
    } else {
      return avPlaces;
    }
  };

  const remainingPlacesMuseum = (selectedTicket) => {
    const tickets = cart.filter(
      (obj) =>
        obj.item.disponibilita !== 1000 &&
        moment(obj.dateTimeSelected).isSame(selectedTicket.dateTimeSelected)
    );
    if (tickets.length > 0) {
      var ticketsQuantity = 0;
      tickets.forEach((element) => {
        ticketsQuantity += element.quantity;
      });
      return capacity - ticketsQuantity;
    } else {
      return capacity;
    }
  };

  function plusItem(item, index) {
    if (item && item.item && item.item.museumTicket) {
      if (remainingPlacesMuseum(item) > 0) {
        const copyCart = [].concat(cart);
        copyCart[index].quantity += 1;
        updateCart(copyCart);
      } else {
        setProblematicDateTime(item.dateTimeSelected);
        setShowEntrancesWarning(true);
      }
    } else {
      let evento_child = null;
      const indexToFind = events.findIndex(
        (e) => e.id === item.item.schema_eventi.id
      );
      if (indexToFind >= 0) {
        evento_child = events[indexToFind].eventi_child.find((child) =>
          moment(child.ora_inizio).isSame(item.dateTimeSelected)
        );
        if (remainingPlaces(evento_child) > 0) {
          const copyCart = [].concat(cart);
          copyCart[index].quantity += 1;
          updateCart(copyCart);
        } else {
          setShowPlacesWarning(true);
        }
      }
    }
  }

  function minusItem(item, index) {
    const copyCart = [].concat(cart);
    if (item.quantity === 1) {
      copyCart.splice(index, 1);
    } else {
      copyCart[index].quantity -= 1;
    }
    updateCart(copyCart);
    setProblematicDateTime("");
    setShowPlacesWarning(false);
    setShowEntrancesWarning(false);
  }

  function updateQuantityHg(type, el, index) {
    const copyCart = [].concat(cart);
    // if (item.quantity === 1) {
    //   copyCart.splice(index, 1);
    // } else {
    //   copyCart[index].quantity -= 1;
    // }

    const levelValue = !Number.isNaN(Number(el.gLevel))
      ? Number(el.gLevel)
      : 100;
    if (type === "plus") {
      copyCart[index].additionalKey = `M+${copyCart[index].additionalKey}`;
      copyCart[index].hg += levelValue;
    } else {
      copyCart[index].additionalKey = `M-${copyCart[index].additionalKey}`;
      copyCart[index].hg -= levelValue;
    }

    // const calcLevel = levelValue / 100;
    // if (type === "minus") {
    //   copyQuantityHg -= calcLevel;
    // } else {
    //   copyQuantityHg += calcLevel;
    // }
    updateCart(copyCart);
    // setQuantityHg(copyQuantityHg);
  }

  const {
    totalPrice,
    servicesFees,
    // deliveryCost,
    // allCoverPrice,
    // total,
    cartCounter,
    totToShow, // totalPrice + servicesFees + deliveryCost,
    totToShowEuro,
  } = cartParams;

  const logo = customStyle.logo || require("assets/img/logo.png");
  // const location = useLocation();
  // eslint-disable-next-line
  const { path } = pathSplit(
    location && location.pathname ? location.pathname : "",
    ""
  );

  const openEventInfoModal = (eventData) => {
    setShowModalEventInfo(eventData);
  };

  function checkCartQuantity(cartToCheck) {
    var totQuantity = 0;
    if (cartToCheck.length !== 0) {
      cartToCheck.forEach((element) => {
        totQuantity += element.quantity;
      });
    }
    if (totQuantity <= 7) {
      return true;
    } else {
      return false;
    }
  }

  useEffect(() => {
    if (!checkCartQuantity(cart)) {
      setShowCartFullWarning(true);
    } else {
      setShowCartFullWarning(false);
    }
    // eslint-disable-next-line
  }, [cart]);

  return (
    <>
      {cart && Array.isArray(cart) && cart.length > 0 ? (
        <div style={{ paddingTop: "35px" }}>
          <Hidden smDown implementation="css">
            <div className={classes.containerMenu}>
              {/* <Link to={}> */}
              {showGoToCheckout && (
                <Button
                  round={false}
                  size="sm"
                  color="lightBlue"
                  className={classes.buttonBig}
                  style={{
                    backgroundColor: customStyle.buttonAction,
                  }}
                  // color="info"
                  onClick={() => {
                    if (
                      museum &&
                      museum.delivery &&
                      museum.delivery.minTotal &&
                      museum.delivery.minTotal > totToShowEuro
                    ) {
                      setShowAlert(true);
                    } else {
                      var url = history.location.pathname;
                      var home = history.location.pathname;
                      home = home.slice(url.lastIndexOf("/"), home.length);

                      history.push(`/${museum.identificativo}/contacts${home}`);
                      closeCartSideBar();
                    }
                  }}
                >
                  <span className={classes.buttonBigText}>
                    {t("cart.checkout")}
                  </span>
                </Button>
              )}
              {/* </Link> */}
            </div>
          </Hidden>
          <p
            className={classes.eventText}
            style={{ fontSize: "20px", padding: "20px", textAlign: "center" }}
          >
            {t("cart.orderSummary")}
          </p>
          {showEntrancesWarning && (
            <p
              style={{
                fontSize: "14px",
                padding: "20px",
                textAlign: "center",
                color: "darkred",
                fontWeight: 700,
              }}
            >
              {t("cart.tooManyTicketsForTheSlot")}
              {"'"}
              {problematicDateTime.split("T")[0].split("-")[2]}
              {"/"}
              {problematicDateTime.split("T")[0].split("-")[1]}
              {"/"}
              {problematicDateTime.split("T")[0].split("-")[0]}{" "}
              {problematicDateTime.split("T")[1].split(":")[0]}
              {":"}
              {problematicDateTime.split("T")[1].split(":")[1]}
              {"'"}
            </p>
          )}
          {isMobile && (
            <div
              style={{
                display: "flex",
                cursor: "pointer",
                justifyContent: "center",
              }}
              onClick={() => setShowMoreActive((val) => !val)}
            >
              {showMoreActive ? (
                <>
                  <ExpandLessIcon />
                  <p
                    className={classes.eventText}
                    style={{
                      fontSize: "15px",
                      padding: "0",
                      textAlign: "center",
                      fontWeight: "normal",
                    }}
                  >
                    {t("cart.hideDetails")}
                  </p>
                </>
              ) : (
                <>
                  <ExpandMoreIcon />
                  <p
                    className={classes.eventText}
                    style={{
                      fontSize: "15px",
                      padding: "0",
                      textAlign: "center",
                      fontWeight: "normal",
                    }}
                  >
                    {t("cart.showDetails")}
                  </p>
                </>
              )}
            </div>
          )}
          {(!isMobile || showMoreActive) &&
            cart.map((el, index) => {
              if (!el.price && el.item && el.item.prezzo) {
                el.price = el.item.prezzo;
              }
              let price = priceTotal([el], currency).toFixed(2);
              if (!price && el.item && el.item.prezzo) {
                price = el.item.prezzo.toFixed(2);
              }

              return (
                <div
                  key={`sidebarCart_${el.productId}_${el.additionalKey}`}
                  className={classes.containerMenu}
                >
                  <span className={classes.eventText}>
                    {el?.item?.schema_eventi?.nome_evento &&
                      el?.item?.schema_eventi?.nome_evento}{" "}
                  </span>
                  <br />
                  <span className={classes.eventText}>
                    {moment(el?.dateTimeSelected)?.format("DD/MM/YY HH:mm")}
                  </span>
                  <div className={classes.ticketTextContainer}>
                    <h3 className={classes.dishName}>
                      {el.item && el.item.id && el.item.nome_articolo
                        ? el.item.nome_articolo
                        : el.item && el.item.nome
                        ? el.item.nome
                        : ""}
                    </h3>
                    {el.item && el.item.museumTicket ? null : (
                      <IconButton
                        onClick={() =>
                          openEventInfoModal(el.item?.schema_eventi)
                        }
                      >
                        <InfoIcon />
                      </IconButton>
                    )}
                  </div>
                  {el.item && (
                    <div
                      style={{
                        borderBottom: "solid 1px #cbcbcb",
                      }}
                    >
                      {showPlacesWarning && !el.item.museumTicket && (
                        <p
                          style={{
                            fontWeight: 700,
                            color: "darkred",
                            marginBottom: 0,
                          }}
                        >
                          {t("only")}{" "}
                          {
                            events
                              .find((e) => e.id === el.item.schema_eventi.id)
                              .eventi_child.find((child) =>
                                moment(child.ora_inizio).isSame(
                                  el.dateTimeSelected
                                )
                              ).posti_disponibili
                          }{" "}
                          {events
                            .find((e) => e.id === el.item.schema_eventi.id)
                            .eventi_child.find((child) =>
                              moment(child.ora_inizio).isSame(
                                el.dateTimeSelected
                              )
                            ).posti_disponibili === 1
                            ? t("oneLeft")
                            : t("fewLeft")}
                        </p>
                      )}
                      <div
                        className={classes.containerDish}
                        style={{ width: "100%" }}
                      >
                        <AddItemCustom
                          cart={cart}
                          quantity={el.quantity}
                          updateQuantity={(type) => {
                            if (type === "minus") {
                              minusItem(el, index);
                            } else {
                              plusItem(el, index);
                            }
                          }}
                          selectItem={el}
                          customStyle={customStyle}
                          isIngredientsPerHg={!!el.isPricePerHg}
                          currency={currency}
                          minQuantityHg={
                            !Number.isNaN(Number(el.gMin))
                              ? Number(el.gMin) / 100
                              : 1
                          }
                          maxQuantityHg={
                            !Number.isNaN(Number(el.gMax))
                              ? Number(el.gMax)
                              : 10000
                          }
                          quantityHg={el.hg / 100}
                          updateQuantityHg={(type) => {
                            updateQuantityHg(type, el, index);
                          }}
                          showEdit
                          totPrice={price}
                          isSize={false}
                          type={"cart"}
                          singlePrice={
                            el.price
                              ? el.price?.toFixed(2)
                              : el.item && el.item.prezzo
                              ? el.item.prezzo.toFixed(2)
                              : ""
                          }
                        />
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          <div className={classes.containerMenu}>
            <div
              style={{
                borderBottom: "solid 1px #cbcbcb",
              }}
            >
              <div>
                {showCartFullWarning && (
                  <p style={{ fontWeight: 500, color: "darkred" }}>
                    {t("cartFull")}
                  </p>
                )}
                <div className={classes.containerDish}>
                  <div className={classes.dishName} style={{ float: "right" }}>
                    {t("cart.ticketNumber")}
                  </div>
                </div>
                <div
                  className={classes.priceText}
                  style={{ float: "right", lineHeight: "30px" }}
                >
                  {cartCounter}
                </div>
              </div>

              <div>
                <div className={classes.containerDish}>
                  <div className={classes.dishName} style={{ float: "right" }}>
                    {t("cart.subtotal")}
                  </div>
                </div>
                <div
                  className={classes.priceText}
                  style={{ float: "right", lineHeight: "30px" }}
                >
                  {totalPrice.toFixed(2)}
                  {currency && currency.symbol ? currency.symbol : ""}
                </div>
              </div>

              {cartParams && cartParams.discount ? (
                <div>
                  <div className={classes.containerDish}>
                    <div
                      className={classes.dishName}
                      style={{ float: "right" }}
                    >
                      {t("cart.discount")}
                    </div>
                  </div>
                  <div
                    className={classes.priceText}
                    style={{
                      float: "right",
                      lineHeight: "30px",
                      fontWeight: "normal",
                    }}
                  >
                    -{cartParams.discount.toFixed(2)}
                    {currency && currency.symbol ? currency.symbol : ""}
                  </div>
                </div>
              ) : null}
              <div>
                <div className={classes.containerDish}>
                  <div className={classes.dishName} style={{ float: "right" }}>
                    {t("cart.service_fees")}
                  </div>
                </div>
                <div
                  className={classes.priceText}
                  style={{
                    float: "right",
                    lineHeight: "30px",
                    fontWeight: "normal",
                  }}
                >
                  {servicesFees.toFixed(2)}
                  {currency && currency.symbol ? currency.symbol : ""}
                </div>
              </div>
            </div>
          </div>
          <div className={classes.containerMenu}>
            <div className={classes.containerDish}>
              <div className={classes.dishName} style={{ float: "right" }}>
                {t("cart.total")}
              </div>
            </div>
            <div
              className={classes.priceText}
              style={{ float: "right", lineHeight: "30px" }}
            >
              {totToShow.toFixed(2)}
              {currency && currency.symbol ? currency.symbol : ""}
            </div>
          </div>
          <PromotionalCode {...props} />

          {museum && museum.delivery && museum.delivery.minTotal ? (
            <div className={classes.minTotal}>
              <span style={{ fontWeight: "bold" }}>
                {t("cart.min_total_title")}
              </span>
              <div>
                <span style={{ fontStyle: "italic" }}>
                  {t("cart.min_total_description")}{" "}
                  {calculateValueCurrency(
                    museum.delivery.minTotal,
                    currency
                  ).toFixed(2)}
                  {currency.symbol}
                </span>
              </div>
            </div>
          ) : null}
          {museum &&
          museum.delivery &&
          museum.delivery.messagePromotion &&
          museum.delivery.messagePromotion[language] ? (
            <div className={classes.minTotal}>
              {ReactHtmlParser(museum.delivery.messagePromotion[language])}
            </div>
          ) : null}
        </div>
      ) : (
        <div>
          {/* EMPTY CART*/}
          <Hidden smDown implementation="css">
            <div className={classes.containerMenu}>
              {/*<Link to={`menu`}>
                <Button
                  round={false}
                  size="sm"
                  color="lightBlue"
                  className={classes.buttonBig}
                  style={{
                    backgroundColor: customStyle.buttonAction
                    // backgroundColor: undefined
                  }}
                  // color="info"
                  onClick={() => {
                    // TODO GO TO TICKETS ADD ANCHOR
                  }}
                >
                  <span className={classes.buttonBigText}>
                    {t("cart.add_tickets")}
                  </span>
                </Button>
              </Link>*/}
            </div>
          </Hidden>
          <div className={classes.emptyCart}>
            <ShoppingBasketIcon
              style={{
                margin: "20px",
                fontSize: "45px",
                color:
                  "rgba(" +
                  hexToRgb(customStyle.buttonCart || warningColor[0]) +
                  ", 0.7)",
              }}
            />
            <div style={{ fontStyle: "italic", color: "#696969" }}>
              {t("cart.empty_cart")}
            </div>
          </div>
        </div>
      )}
      <Hidden smDown implementation="css">
        <div className={classes.logo}>
          <img src={logo} alt="logo" className={classes.img} />
        </div>
      </Hidden>
      {/*<AlertMinTotal
        showAlert={!!showModalEventInfo}
        updatePopUp={() => {
          setShowModalEventInfo(false);
        }}
        danger={false}
        body={
          <div
            className={classes.alertEventContainer}
            style={{ backgroundColor: "white" }}
          >
            <img src={showModalEventInfo?.immagine_evento &&
            showModalEventInfo?.immagine_evento?.url
              ? showModalEventInfo?.immagine_evento?.url
              : museum?.cover?.url} alt="" />
            <span style={{ fontWeight: "bold" }}>
              {showModalEventInfo?.nome_evento}
            </span>
          </div>
        }
      />*/}

      <EventInfoAlert
        eventData={showModalEventInfo}
        setEventData={setShowModalEventInfo}
        museum={museum}
      />

      <AlertMinTotal
        showAlert={showAlert}
        updatePopUp={() => {
          setShowAlert(false);
        }}
        body={
          <div
            className={classes.minTotal}
            style={{ backgroundColor: "white" }}
          >
            <span style={{ fontWeight: "bold" }}>
              {t("cart.min_total_title")}
            </span>
            {museum && museum.delivery && museum.delivery.minTotal ? (
              <div>
                <span style={{ fontStyle: "italic" }}>
                  {t("cart.min_total_description")}{" "}
                  {calculateValueCurrency(
                    museum.delivery.minTotal,
                    currency
                  ).toFixed(2)}
                  {currency.symbol}
                </span>
              </div>
            ) : null}
          </div>
        }
      />
    </>
  );
}

SidebarCart.propTypes = {
  cart: PropTypes.arrayOf(PropTypes.object).isRequired,
  museum: PropTypes.object.isRequired,
  currency: PropTypes.shape({
    name: PropTypes.string,
    rate: PropTypes.number,
    symbol: PropTypes.string,
  }).isRequired,
  shippingInfo: PropTypes.shape({
    type: PropTypes.string,
    floor: PropTypes.any,
  }).isRequired,
  cartParams: PropTypes.shape({
    totalPrice: PropTypes.number,
    deliveryCost: PropTypes.number,
    servicesFees: PropTypes.number,
    allCoverPrice: PropTypes.number,
    total: PropTypes.number,
    discount: PropTypes.number,
    cartCounter: PropTypes.number,
    totToShow: PropTypes.number,
    totToShowEuro: PropTypes.number,
    discountEuro: PropTypes.number,
    allCoverPriceEuro: PropTypes.number,
  }).isRequired,
  language: PropTypes.string.isRequired,
  updateCart: PropTypes.func.isRequired,
  history: PropTypes.any,
  customStyle: PropTypes.object,
  events: PropTypes.arrayOf(PropTypes.object).isRequired,
};
SidebarCart.defaultProps = {
  customStyle: {},
};

export default withRouter(SidebarCart);
